<template>
  <Teleport to="body">
    <div v-bind="$attrs" class="modal-core" :class="(theme === 'primary') ?  'modal-core--primary' : ''" role="dialog">
      <div class="modal-core__content">
        <div class="modal-core__button-close" @click="close" aria-label="Close">✕</div>
        <div class="modal-core__body">
          <slot></slot>
        </div>
      </div>
      <div class="modal-core-close" @click="close" aria-label="Close"></div>
    </div>
  </Teleport>
</template>

<script>
import Teleport from 'vue2-teleport';
export default {
  props: ['theme'],
  components: {
    Teleport,
  },
  mounted() {
    document.querySelector('html').style.overflow = 'hidden'
    document.querySelector('body').style.overflow = 'hidden'
  },
  destroyed(){
    document.querySelector('html').style.overflow = 'auto'
    document.querySelector('body').style.overflow = 'auto'
  },
  methods:{
    close(){
      this.$emit('close');
      document.querySelector('html').style.overflow = 'auto'
      document.querySelector('body').style.overflow = 'auto'
    }
  }

}
</script>